import React, { useId } from 'react';
import { Alert, Button, DialogActions, DialogContent, DialogTitle, Modal, ModalDialog } from '@mui/joy';
import { getApiErrorMessage } from '../../lib/apiError';

export const ConfirmDeleteDialog: React.FC<{
  open: boolean;
  label: string;
  children: React.ReactNode;
  pending: boolean;
  error: unknown;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ open, label, children, pending, error, onClose, onConfirm }) => {
  const id = useId();
  return (
    <Modal open={open} onClose={() => { if (!pending) onClose(); }}>
      <ModalDialog
        role="alertdialog"
        aria-labelledby={`${id}-title`}
        aria-describedby={`${id}-description`}
        sx={{ width: 'min(480px, calc(100vw - 32px))' }}
      >
        <DialogTitle id={`${id}-title`}>{label}?</DialogTitle>
        <DialogContent id={`${id}-description`}>{children}</DialogContent>
        {Boolean(error) && (
          <Alert color="danger" role="alert">
            {getApiErrorMessage(error, 'This could not be deleted. Please try again.')}
          </Alert>
        )}
        <DialogActions>
          <Button color="danger" loading={pending} onClick={onConfirm}>{label}</Button>
          <Button autoFocus variant="plain" color="neutral" disabled={pending} onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};
